
import React, {Component} from "react";

import "./badge.css";


class Badge extends Component {
    render () {
        let {badge_info, current} = this.props;

        let imageClass = "progress_map_badge_image";
        let badgeClass = "progress_map_badge";
        let showBadgeName = true;
        let badgeTitle = badge_info.title;
        if (current) {
            imageClass += " current";
            badgeClass += " current";
            showBadgeName = false;

            badgeTitle = badge_info.name + ": " + badgeTitle;
        }

        return (
            <div className={badgeClass}>
                <div className='progress_map_badge_image_container' title={badgeTitle}>
                    <img alt={badge_info.name + "_badge"} className={imageClass} src={require(`./badges/${badge_info.image_path}`)}></img>
                    {showBadgeName && <div className='progress_map_badge_text'>{badge_info.name}</div>}
                </div>
            </div>
        );
    }
}

export default Badge;



// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/widgets/badge.js